import { Fragment } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import {
	setModalNewsId,
	setModalNewsVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledDivider,
	StyledNewsContainer,
	StyledNewsHead,
	StyledNewsItemContainer,
	StyledNoNewsContainer,
	StyledTextContainer,
} from './News.styled';

const News = () => {
	const dispatch = useLayoutDispatch();
	const newsPosts = useObservable(rage.game.getServerNewsPosts());

	return (
		<ScrollContainer
			height={940}
			scrollbarHeight={900}
			style={{ marginTop: 20 }}
		>
			<StyledNewsContainer tabIndex={-1}>
				{newsPosts.map((newsPost, index) => (
					<Fragment key={index}>
						<StyledNewsItemContainer>
							<StyledNewsHead>
								<Text>{newsPost.title}</Text>
								<Text>
									{new Date(newsPost.date).toLocaleDateString('ru-RU', {
										timeZone: 'Europe/Moscow',
									})}
								</Text>
							</StyledNewsHead>
							<StyledTextContainer>
								<Text>{newsPost.shortText}</Text>
							</StyledTextContainer>
							<Button
								color={ButtonColors.Default}
								height={ButtonHeight.Height40}
								style={{ fontSize: 14, width: 157 }}
								onClick={() => {
									dispatch(setModalNewsVisible(true));
									dispatch(setModalNewsId(newsPost.id));
								}}
							>
								<Text>Читать подробнее</Text>
							</Button>
						</StyledNewsItemContainer>
						<StyledDivider />
						{index === newsPosts.length - 1 && (
							<Text
								style={{
									fontSize: 16,
									color: '#ffffff',
									opacity: 0.1,
									textAlign: 'center',
								}}
							>
								Вы посмотрели все свежие новости
							</Text>
						)}
					</Fragment>
				))}
				{!newsPosts.length && (
					<StyledNoNewsContainer>
						<Text>К сожалению, но пока новостей нет...</Text>
					</StyledNoNewsContainer>
				)}
			</StyledNewsContainer>
		</ScrollContainer>
	);
};

export { News };
